export default "__VITE_ASSET__StEAWhNW__"